import VideoPreviewGrid from "../../Components/modern/VideoPreviewGrid";
import { Container } from "../../Components/modern/UI";
import { mediaVideos } from "../../Data/mediaData";

export default function VideoGallery() {
  return (
    <>
      <section className="sn-border-b sn-border-line sn-py-12 md:sn-py-16">
        <Container>
          <h1 className="sn-font-display sn-text-4xl sn-leading-tight sn-tracking-[-0.04em] sn-text-forest md:sn-text-5xl">Video Gallery</h1>
        </Container>
      </section>

      <section aria-label="Video gallery videos" className="sn-pb-12 md:sn-pb-16">
        <Container>
          <VideoPreviewGrid videos={mediaVideos} title="Suryanirbhar video" columns="sm:sn-grid-cols-2 lg:sn-grid-cols-3" />
        </Container>
      </section>
    </>
  );
}
